module.exports = __webpack_public_path__ + "media/images/emblems/CheneBourg-coat_of_arms-feb071626c7c2166a6f48c8643f05334.svg";